<template>
    <div>
        <div class="row">
            <div class="col-3">
                <ul class="list-group list-group-flush font-weight-normal" v-if="leftDescriptionTable.length > 0">
                    <li class="list-group-item p-1 border-0">Keterangan : </li>
                    <li class="list-group-item p-1 border-0" v-for="(desc, index) in leftDescriptionTable" :key="index">
                        <span :class="desc.bg" class="px-4 py-1 mr-2"></span>{{ desc.lable }}
                    </li>
                    <li class="list-group-item p-1"></li>
                </ul>
            </div>
            <div class="col-4">
                <ul class="list-group list-group-flush font-weight-normal" v-if="rightDescriptionTable.length > 0">
                    <li class="list-group-item p-1 border-0">Keterangan Status Data: : </li>
                    <li class="list-group-item p-1 border-0" v-for="(desc, index) in rightDescriptionTable" :key="index">
                        <span :class="desc.bg" class="px-4 py-1 mr-2"></span>{{ desc.lable }}
                    </li>
                    <li class="list-group-item p-1"></li>
                </ul>
            </div>
        </div>
        <div class="mb-3 ml-1">
            Notes
            <el-tooltip class="item" effect="dark" placement="top">
                <template #content>
                    Metode Minimasi Regret, Prob. Kerusakan diasumsikan nilai ROP, MAX, dan Safety Stock adalah sama
                </template>
                <span style="
                    font-size: 10px;
                    cursor: pointer;
                    margin-left: 2px;
                    ">
                    <i class="fa fa-exclamation-circle"></i>
                </span>
            </el-tooltip>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'TableInformation1',
    props: {
        leftDescriptionTable: {
            type: Array,
            required: true
        },
        rightDescriptionTable: {
            type: Array,
            required: true
        },
    },
};
</script>